export const landingAnchorRoutes = {
    investors: {
        route: '#investors',
        name: 'Инвесторам',
    },
    registration: {
        route: 'registration',
        name: 'Документы',
    },
    documents: {
        route: 'information',
        name: 'Выпуски',
    },
};
